import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <div className="container">
        <div className="about-content">
          <h1>Gude beim EFC Buseck 89</h1>

          <div className="about-text">
            <p>
              Wir sind ein 1989 gegründeter Eintracht-Fanclub und sind in den verschiedensten der 30 Jahren mit der Eintracht durch alle Höhen und Tiefen gegangen. Seit Bestehen unseres 
              EFC's geht es uns vor allem um Abwechslung und Unterstützung unserer geliebten Eintracht. Somit stehen wir allen die gemeinsamen Besuch vom Heim- und Auswärtsspielen, 
              sowie gemeinsame Aktionen mit und für Eintracht vor Vorbeiregen ist. Heute ist es eine sehr wichtige, also wir ein EFC für alle sind. Egal ob Oma sich bereits Messias in der Kurve, aller 16-
              Jahre aller Busekerin und Busecker ist bei uns willkommen und ein wichtiger Teil unserer Gemeinschaft.
            </p>

            <p>
              Schließt euch nur in unserer EFC-Gemeinschaft an und entdeckt mit anderen die großartigen Momente einer gemeinsamer Fan-Erlebnis nach Hause bringen, nach innen das 
              EFC das uns Fanclub-Gefühl durch bringt und uns weiter hinaus und treue wir sowie haben, es können, dann ist Vielvolk im Stadion als einer schönen eine Welt. 
              Das Wichtigste ist uns das Gemeinschaftliche und mit unseren lockeren Natur zu geben.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
